import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from "./layouts/Footer";
import Header from "./layouts/Header"
//import { Dimensions, Application, Gallery, Aboutus, Notice,Network } from './Pages';
import Dashboard from './Pages/Dashboard';
// import Application from './Pages/Application';
import Dimensions from "./Pages/Dimensions";
// import Gallery from "./Pages/Gallery";
// import Aboutus from "./Pages/Aboutus";
import Notice from "./Pages/Notice"
import Network from "./Pages/Network";
import "./App.css"
import Kovida from './Pages/Dimensions/Kovida';
import SportsPrograms from './Pages/Dimensions/SportsPrograms';
import JanaNidhi from './Pages/Dimensions/JanaNidhi';
import BioEnergy from './Pages/Dimensions/BioEnergy';
import JanAushadhi from './Pages/Dimensions/JanAushadhi';
import Yuvasahakar from './Pages/Dimensions/Yuvasahakar';
import Kaushalyasetuform from './Pages/Forms/Kaushalyasetuform';
import JanAushadhiForm from './Pages/Forms/JanAushadhiForm';
import Profile from './Pages/AboutUs/Profile';
import Board from './Pages/AboutUs/Board';
import JanaNidhiDetails from './Pages/JanaNidhiDetails';
import Photos from './Pages/Gallery/Photos';
import Videos from './Pages/Gallery/Videos';
import Contact from './Pages/Contact/Contact';
import StudentChapter from './Pages/StudentChapter/StudentChapter';
import Whatsapp from './components/Whatsapp';
import YuvaExpoPage from './Pages/Dimensions/YuvaExpoPage';
import Events from "./Pages/Events";
import FormApplication from './Pages/FormApplication';
import MrSpecialist from './Pages/MrSpecialist';
import MajorActivities from './Pages/AboutUs/MajorActivities';
import BlogDetailPage from './Pages/Blogs/BlogDetailPage';
import PrivacyPolicy from './Pages/Privacy/PrivacyPolicy';
import TermsAndConditions from './Pages/Privacy/TermsAndConditions';
import Login from './Pages/Authourization/Login';
import ProtectedRoute from './layouts/ProtectedRoute';
import PostBlog from './Pages/Blogs/PostBlog';
import Blogs from './Pages/Blogs/Blogs';
import SignUp from './Pages/Authourization/SignUp';
function App() {
  return (
    <>
      <Router>
        <Header />

        <Routes>
          {/* Main routes */}
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/MrSpecialist" element={<MrSpecialist />} />

          {/* <Route path="/Dimensions" element={<Dimensions />} />
          <Route path="/Network" element={<Network />} />
          <Route path="/apply" element={<Application />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/gallery" element={<Gallery />} /> */}
          <Route path="/Notice" element={<Notice />} />
          <Route path="/" element={<Dashboard />} />

          {/* Nested routes */}
          <Route path="/about/story" element={<Profile />} />
          <Route path="/about/team" element={<div>Vision & Mission Page</div>} />
          <Route path="/about/vision" element={<Board />} />
          <Route path="/about/activities" element={<MajorActivities />} />
          <Route path="/about/events" element={<Events />} />
          <Route path="/dimensions/Kovida" element={<Kovida />} />
          <Route path="/dimensions/Sports" element={<SportsPrograms />} />
          <Route path="/dimensions/JanaNidhi" element={<JanaNidhiDetails />} />
          <Route path="/dimensions/Bioenergy" element={<BioEnergy />} />
          <Route path="/dimensions/YuvaExpo" element={<YuvaExpoPage />} />
          <Route path="/dimensions/YuvaSahkar" element={<Yuvasahakar />} />
         
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          {/* <Route path="/network/KaushalyaMap" element={<div>Kashyala map</div>} />
          <Route path="/network/PMKVY" element={<div>PMKVY Centers</div>} />
          <Route path="/network/GAILS" element={<div>GAIL-Raftaar-Map</div>} />
          <Route path="/network/SRContact" element={<div>SR Contact List</div>} /> */}
          <Route path="/KaushalyaSethuAbhiyanForm" element={<Kaushalyasetuform />} />
          {/* <Route path="/JanaNidhiForm" element={<JanaNidhiDetails/>} /> */}
          <Route path="/JanAushadhi" element={<JanAushadhiForm />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/StudentChapter" element={<StudentChapter />} />
          {/* <Route path="/Events" element={<Events/>} /> */}
          <Route path='/FormApplication' element={<FormApplication />} />
          <Route path="*" element={<Dashboard />} />
           <Route path="/login" element={<Login />} />
           <Route path="/sign-up" element={<SignUp/>}/>
        {/* Protected Pages */}
        <Route
          path="/blogs"
          element={
            <ProtectedRoute>
              <Blogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/post-blog"
          element={
            <ProtectedRoute>
              <PostBlog />
            </ProtectedRoute>
          }
        />
        <Route
         path="/blogs/:id"
         element={
            <ProtectedRoute>
             <BlogDetailPage />
            </ProtectedRoute>
          }
        />
        </Routes>
        <Footer />

        <Whatsapp />
      </Router>
    </>
  );
}

export default App;
